<ng-template #displayTemplateRef
             let-cellData
             let-rowData="rowData">
  @if (checkHasValue(cellData)) {
    <a scOverflowTooltip
       (click)="invokeAction(rowData, cellData)">
      {{ isDate ? (getCellValue(cellData) | date) : (getCellValue(cellData)) }}</a>
  }
</ng-template>